import { ColumnsType } from "antd/es/table";
import { ReactNode, useMemo } from "react";
import { IFillableFormListItem } from "../types";
import { TableActions } from "../components/TableActions";
import { FillableFormVisibilityLabel } from "../components/FillableFormVisibilityLabel";

export const useTableColumns = (
  setOpenedItem: React.Dispatch<
    React.SetStateAction<string | null | undefined>
  >,
  reloadData: () => void,
) => {
  const columns: ColumnsType<IFillableFormListItem> = useMemo(
    () => [
      {
        title: "Name",
        dataIndex: "name",
        width: "23%",
        ellipsis: true,
      },
      {
        title: "Description",
        dataIndex: "description",
        width: "60%",
      },
      {
        title: "Portal Visibility",
        dataIndex: "visibility",
        width: "12%",
        render: (val: 0 | 1 | 2 | 3): ReactNode => (
          <FillableFormVisibilityLabel val={val} tooltipLabel="form" />
        ),
      },
      {
        dataIndex: "actions",
        width: "5%",
        render: (_, record: IFillableFormListItem) => (
          <TableActions
            id={record.id}
            fileName={record.fileName}
            setOpenedItem={setOpenedItem}
            reloadData={reloadData}
          />
        ),
      },
    ],
    [setOpenedItem, reloadData],
  );

  return { columns };
};
